module.exports = __webpack_public_path__ + "static/media/air-conditioning.72b88ce7.svg";